import { render, staticRenderFns } from "./HeadLine.vue?vue&type=template&id=65229b14&scoped=true&"
import script from "./HeadLine.vue?vue&type=script&lang=ts&"
export * from "./HeadLine.vue?vue&type=script&lang=ts&"
import style0 from "./HeadLine.vue?vue&type=style&index=0&id=65229b14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65229b14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
